import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { AdminService } from 'src/app/public/landing/services/admin.service';
import { AdminViewModel } from 'src/app/models/AdminViewModel';
import { UserApiQuotaVM } from 'src/app/models/UserApiQuotaVM';
import { Validators, FormBuilder, FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { UpgradedMethods } from 'src/app/Enum/Enum';
import { UserService } from 'src/app/core-services/user.service';
import { UserApiQuotaService } from 'src/app/public/landing/services/user-api-quota.service';
import { PlanService } from 'src/app/public/landing/services/plan.service';
import { AllValidationErrors, getFormValidationErrors } from 'src/app/helper/get-form-validation-errors';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
export interface UpgradeMethods {
  Id: number;
  Value: string;
}

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.scss']
})
export class UserListComponent implements OnInit {

  constructor(private adminService: AdminService, private fb: FormBuilder, private toastr: ToastrService, private spinner: NgxSpinnerService,
    private userService: UserService, private userApiQuotaService: UserApiQuotaService, private planService: PlanService,  private modalService: NgbModal) { }
  requestVM: any;
  userData: any;
  totalcount: any;
  planlist: any;
  selectedplan: any;
  selectedMethod: any;
  submitted: boolean = false;
  minDate: Date;
  rageYears: string;
  isManual: boolean = false;
  hasAdminRight=false;
  @ViewChild('editUserModal', { static: false }) editUserModal: any;
  modalRef: NgbModalRef | null = null;


  upgradeMethods: UpgradeMethods[] = [
    { Id: 1, Value: 'Paypal' },
    { Id: 2, Value: 'Manual' }
  ]

  UsersForm = this.fb.group({
    UserName: ['', Validators.required],
    EmailId: ['', Validators.required],
    planId: ['', Validators.required],
    UserId: ['', Validators.required],
    IsAdministrator: new FormControl(false),
    upgradeId: [''],
    expiryDate: [''],
    maxRequestAllowed: ['',],
    requestExhausted: new FormControl(0),
    startDate: [''],
    endDate: [''],
    apiKey: ['']
  });
  ngOnInit() {
    this.minDate = new Date();
    this.rageYears = this.minDate.getUTCFullYear() + ':' + (this.minDate.getUTCFullYear() + 50);
    this.requestVM = new AdminViewModel();
    this.requestVM.pageNo = 1;
    this.requestVM.pageSize = 10;
    this.getplanList();
    this.getuserList();

  }

  @ViewChild('closeuserModal') closeuserModal: ElementRef;

  getuserList() {
    if (this.requestVM != null && this.requestVM.pageNo > 0 && this.requestVM.pageSize > 0) {
      this.spinner.show();
      this.userService.GetuserList(this.requestVM).subscribe((response: any) => {
        if (response != null && response.data != null && response.succeeded) {
          this.userData = response.data;
          this.totalcount = response.totalRecords;
          this.spinner.hide();
        }
        this.spinner.hide();
      })
    }
  }

  paginate(event) {
    this.requestVM.pageNo = event.page + 1;
    this.requestVM.pageSize = event.rows;
    this.getuserList();
  }

  filterSearch(searchText) {
    this.requestVM.pageNo = 1;
    this.requestVM.pageSize = 10;
    this.requestVM.searchText = searchText;
    this.getuserList();
  }

  openEditUserModal(id: any) {
    this.getUserdetails(id); 

    this.modalRef = this.modalService.open(this.editUserModal, {
      size: 'lg',
      centered: true,
      backdrop: 'static'
    });
  }

  getUserdetails(userid) {
    if (userid != null) {
      this.isManual = false;
      this.userService.GetUserDetail(userid).subscribe((response: any) => {
        if (response != null && response.succeeded && response.data != null) {
          this.UsersForm.controls.UserName.setValue(response.data.userName);
          this.UsersForm.controls.EmailId.setValue(response.data.email);
          this.UsersForm.controls.planId.setValue(response.data.planId);
          this.UsersForm.controls.IsAdministrator.setValue(response.data.isAdmin);
          this.hasAdminRight =response.data.isAdmin;
          this.UsersForm.controls.UserId.setValue(userid);
          this.UsersForm.controls.apiKey.setValue(response.data.apiKey);
          if (response.data.planId) {
            var selectedPlan = this.planlist.filter(x => x.id == this.UsersForm.controls.planId.value);
            this.selectedplan = selectedPlan[0];
          }


          // this.UsersForm.controls.maxRequestAllowed.setValue(response.data.maxRequestAllowed);
          // this.UsersForm.controls.requestExhausted.setValue(response.data.requestExhausted);
          // this.UsersForm.controls.apiKey.setValue(response.data.apiKey);
          // if (response.data.apiQuotaStartDate != null && response.data.apiQuotaStartDate != undefined && response.data.apiQuotaStartDate != '') {
          //   var date = new Date(response.data.apiQuotaStartDate);
          //   this.UsersForm.controls.startDate.setValue(date);
          // }
          // else {
          //   this.UsersForm.controls.startDate.setValue('');
          // }

          // if (response.data.apiQuotaEndDate != null && response.data.apiQuotaEndDate != undefined && response.data.apiQuotaEndDate != '') {
          //   var date = new Date(response.data.apiQuotaEndDate);
          //   this.UsersForm.controls.endDate.setValue(date);
          // }
          // else {
          //   this.UsersForm.controls.endDate.setValue('');
          // }

          // if (response.data.isPlanPurchase == true) {
          if (!response.data.upgradeMethod) {
            this.UsersForm.controls.upgradeId.setValue('');
            this.selectedMethod = null;
          }
          else if (response.data.upgradeMethod == UpgradedMethods.Manual) {
            this.UsersForm.controls.upgradeId.setValue(this.upgradeMethods[1] as any);
            this.isManual = true;
            this.selectedMethod = this.upgradeMethods[1];
            if (response.data.planExpiryDate) {
              var date = new Date(response.data.planExpiryDate);
              this.UsersForm.controls.expiryDate.setValue(date as any);
            } else {
              this.UsersForm.controls.expiryDate.setValue('');
            }
          }
          else if (response.data.upgradeMethod == UpgradedMethods.Paypal) {
            this.UsersForm.controls.upgradeId.setValue(this.upgradeMethods[0] as any);
            this.selectedMethod = this.upgradeMethods[0];
            this.isManual = false;
          }         
        }
      })
    }
  }


  getplanList() {
    this.planService.GetAllPlans().subscribe((response: any) => {
      if (response != null && response.data != null) {
        this.planlist = response.data;
        console.log(this.planlist);
        // if (this.UsersForm.controls.planId.value != 'undefined' && this.UsersForm.controls.planId.value != null && this.UsersForm.controls.planId.value > 0) {
        //   var selectleb = this.planlist.filter(x => x.id == this.UsersForm.controls.planId.value);
        //   this.selectedplan = selectleb[0];
        // }
        // else {
        //   var item = {
        //     id: 0,
        //     planName: 'Select Plan'
        //   }
        //   this.planlist.push(item)
        //   this.selectedplan = item;
        // }
      }
    })
  }

  UpdateUser() {
    this.submitted = true;
    if (this.UsersForm.invalid) {
      if (!this.UsersForm.controls.planId.value || (this.UsersForm.controls.planId.value as any)?.id == 0) {
        this.toastr.error("Membership status is required.", "Error!");
        return;
      }
      this.getFormError();
    }

    else {
      let expirydate = '';
      if (this.UsersForm.controls.expiryDate.value != null && this.UsersForm.controls.expiryDate.value != undefined && this.UsersForm.controls.expiryDate.value != '') {
        expirydate = this.dateConvert(this.UsersForm.controls.expiryDate.value);
      }

      // let userApiQuota = new UserApiQuotaVM();

      // if (this.UsersForm.controls.startDate.value != null && this.UsersForm.controls.startDate.value != undefined && this.UsersForm.controls.startDate.value != '') {
      //   userApiQuota.ApiQuotaStartDate = this.dateConvert(this.UsersForm.controls.startDate.value);
      // }

      // if (this.UsersForm.controls.endDate.value != null && this.UsersForm.controls.endDate.value != undefined && this.UsersForm.controls.endDate.value != '') {
      //   userApiQuota.ApiQuotaEndDate = this.dateConvert(this.UsersForm.controls.endDate.value);
      // }

      // userApiQuota.MaxRequestAllowed = Number(this.UsersForm.controls.maxRequestAllowed.value);
      // userApiQuota.RequestExhausted = this.UsersForm.controls.requestExhausted.value ? Number(this.UsersForm.controls.requestExhausted.value) : 0;
      // userApiQuota.ApiKey = this.UsersForm.controls.apiKey.value;
      // userApiQuota.UserId = this.UsersForm.controls.UserId.value;

      // this.userApiQuotaService.SaveUserApiQuota(userApiQuota).subscribe((response1: any) => {
      //   if (response1 != null && response1.succeeded) {
      this.userService.ChangeMemberShipStatus(this.UsersForm.controls.UserId.value, (this.UsersForm.controls.planId.value as any)?.id,
        this.UsersForm.controls.IsAdministrator.value ? true : false, (this.UsersForm.controls.upgradeId.value as any)?.Id, expirydate
      ).subscribe((response: any) => {
        if (response != null && response.succeeded && response.data != null) {
          this.UsersForm.reset();
          // this.closeuserModal.nativeElement.click();
          this.modalRef.close();
          this.toastr.success('Record Has been Updated..!', '');
          this.getuserList();
        }
        else {
          this.UsersForm.reset();
          this.toastr.error('Record not Updated..!', 'Oops');
        }
      })

      //   }
      //   else {
      //     return;
      //   }
      // })
    }
  }

  private getFormError() {
    if (this.UsersForm.controls.UserName.status == 'INVALID') {
      this.toastr.error("User name is required.", "Error!");
      return;
    }
    if (this.UsersForm.controls.EmailId.status == 'INVALID') {
      this.toastr.error("Email is required.", "Error!");
      return;
    }

    if (this.UsersForm.controls.UserId.status == 'INVALID') {
      this.toastr.error("User Id is required.", "Error!");
      return;
    }
    if (this.UsersForm.controls.IsAdministrator.status == 'INVALID') {
      this.toastr.error("Admin right is required.", "Error!");
      return;
    }
    if (this.UsersForm.controls.upgradeId.status == 'INVALID') {
      this.toastr.error("Upgrade Method is required.", "Error!");
      return;
    }
    if (this.UsersForm.controls.maxRequestAllowed.status == 'INVALID') {
      this.toastr.error("Max request allowed is required.", "Error!");
      return;
    }
    if (this.UsersForm.controls.requestExhausted.status == 'INVALID') {
      this.toastr.error("Request Exhausted is required.", "Error!");
      return;
    }

    if (this.UsersForm.controls.startDate.status == 'INVALID') {
      this.toastr.error("Start date is required.", "Error!");
      return;
    }
    if (this.UsersForm.controls.endDate.status == 'INVALID') {
      this.toastr.error("End date is required.", "Error!");
      return;
    }
    if (this.UsersForm.controls.expiryDate.status == 'INVALID') {
      this.toastr.error("Expiry date is required.", "Error!");
      return;
    }
  }

  // Will implement later
  // refreshApiToken() {
  //   let userId = this.UsersForm.controls.UserId.value;
  //   this.userApiQuotaService.RefreshAPIToken(userId).subscribe((response: any) => {
  //     if (response != null && response.succeeded == true && response.data != null) {
  //       this.getUserdetails(this.UsersForm.controls.UserId.value);
  //     }
  //     else {
  //       return;
  //     }
  //   })
  // }

  upgradeMethod(event) {
    this.UsersForm.controls.expiryDate.setValue('');
    if (event != null && event.value != null) {
      if (event.value.Id == UpgradedMethods.Manual) {
        this.UsersForm.get('expiryDate').setValidators(Validators.required);
        this.isManual = true;
        this.UsersForm.controls.expiryDate.setValue(new Date(new Date().getFullYear(), 11, 31) as any);
      }
      else {
        this.UsersForm.get('expiryDate').clearValidators();
        this.UsersForm.controls.expiryDate.setValue(null);
        this.isManual = false;
      }
    }
  }

  dateConvert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

}
